import { useLocation } from 'react-router-dom';
import { WHATSAPP_LINK, WHATSAPP_LINK_POR_ROTA } from '@/data/constants';

/**
 * Link de WhatsApp da página atual, para os botões que aparecem em todas elas
 * (cabeçalho e seção de contato).
 *
 * A mensagem pré-preenchida é o que diz de qual página o contato veio, então
 * cada página de tratamento precisa mandar a sua. Rota sem link próprio usa a
 * mensagem genérica.
 */
export const useWhatsAppLinkDaPagina = (): string => {
  const { pathname } = useLocation();
  const rota = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return WHATSAPP_LINK_POR_ROTA[rota] ?? WHATSAPP_LINK;
};
